module.exports = __webpack_public_path__ + "img/lines.c685fe21.png";